const req_token = ""//请求token
const u_token = ""//账号登录token
const userBase = null

const httpauto = "https://login.bjadks.com/Auth/CheckLoginState?productId=3&redirectUrl="; //免登录
const httplogin = 'https://login.bjadks.com/Auth/Login?bodyClass=kid&redirectUrl='; //登錄
const httpregist = "https://login.bjadks.com/Register?bodyClass=kid&redirectUrl=" //注册
const httploginout = "https://login.bjadks.com/Auth/Logout?redirectUrl=" // 退出
const httpcompany = "https://login.bjadks.com/Auth/CompanyLoginAsToken?comId=" //集团免登录
const http = "https://kids.bjadks.com/"

// const http = "http://localhost:8080/"

import Cookies from 'js-cookie'

function formatDateYMD(time) {
  var datatime = time.replace(/\-/g, "/")
  var datatime = datatime.replace("T", " ")
  const dates = new Date(datatime)
  const year = dates.getFullYear()
  const month = dates.getMonth() + 1
  const date = dates.getDate()
  const day = dates.getDay()
  const hour = dates.getHours()
  const min = dates.getMinutes()
  const days = ['日', '一', '二', '三', '四', '五', '六']
  return {
    allDate: `${year}-${strFormat(month)}-${strFormat(date)}`,
    date: `${strFormat(month)}-${strFormat(date)}`, //返回的日期 07-01
    day: `星期${days[day]}`, //返回的礼拜天数  星期一
    hour: strFormat(hour) + ':' + strFormat(min) //返回的时钟 08:00
  }
}
//字符串拼接
function strFormat(str) {
  return str < 10 ? `0${str}` : str
}
const cate_fr =
  [
    // { "Id": 0, "CatalogName": "首页", "ParentId": 0, "Level": 1, "Order": 1000 },
    // { "Id": 1042, "CatalogName": "0-3岁", "ParentId": 0, "Level": 1, "Order": 1042 },
    // { "Id": 1043, "CatalogName": "3-6岁", "ParentId": 0, "Level": 1, "Order": 1043 },
    // { "Id": 1044, "CatalogName": "6-15岁", "ParentId": 0, "Level": 1, "Order": 1044 },
    // { "Id": 1045, "CatalogName": "老师", "ParentId": 0, "Level": 1, "Order": 1045 },
    // { "Id": 1046, "CatalogName": "家长", "ParentId": 0, "Level": 1, "Order": 1046 },
    // { "Id": 1047, "CatalogName": "绘本馆", "ParentId": 0, "Level": 1, "Order": 1047 },
    // { "Id": 1048, "CatalogName": "电子书城", "ParentId": 0, "Level": 1, "Order": 1048 },
    // { "Id": 1049, "CatalogName": "互动乐园", "ParentId": 0, "Level": 1, "Order": 1049 },
    // { "Id": 1050, "CatalogName": "中小学微课堂", "ParentId": 0, "Level": 1, "Order": 1050 },
    // { "Id": 2940, "CatalogName": "阅读指导", "ParentId": 0, "Level": 1, "Order": 2940 },
    // { "Id": 3054, "CatalogName": "精品乐园", "ParentId": 0, "Level": 1, "Order": 3054 }
  ]
function getCookie(cname) {
  return Cookies.get(cname)
  // var cookies = document.cookie.split(';');
  // console.log(cookies,'----');
  // for (var i = 0; i< cookies.length; i++) {
  // var cookie = cookies[i].trim();
  // if (cookie.indexOf(name + '=') === 0) {
  // return decodeURIComponent(cookie.substring(name.length + 1));
  // }
  // }
}


function setToken(key, token) {
  // return Cookies.set(key, token)
  return Cookies.set(key, token, { domain: '.bjadks.com' })
}

function removeCookie(name) {
  // console.log('清除token');
  return Cookies.remove(name, { domain: '.bjadks.com' })
}

function getUser() {
  if (Cookies.get("tokenUser")) {
    return Cookies.get("tokenUser")
  } else {
    const userString = parseInt(Date.now() / 1000).toString().slice(5) + (Math.floor(Math.random() * 8999) + 1000).toString()
    Cookies.set("tokenUser", userString)
    return userString
  }
}
export default {
  req_token,
  u_token,
  userBase,
  formatDateYMD,
  cate_fr,
  getCookie,
  httpauto,
  httplogin,
  httploginout,
  httpregist,
  httpcompany,
  http,
  removeCookie,
  setToken,
  getUser
}


// WEBPACK FOOTER //
// ./src/utils/common.js